import { StudentDocStatus } from '@/enum/Enum'
//階段步驟
export const FRESHMAN_APPLICATION = {
	Id: null,
	PlanId: null,
	FileId: null,
	ApplicantId: null,
	RecruitApplicationId: null,
	RegisterId: null,
	Name: null,
	LastNameInEnglish: null /*英文姓*/,
	NameInEnglish: null /*英文名*/,
	DepartmentId: null /*系所*/,
	DepartmentInEnglish: null,
	ClassId: null /*班別*/,
	ClassInEnglish: null,
	DateOfBirth: null /*生日*/,
	IdCode: null,
	TypeOfIdentity: null /*國籍*/,
	Sex: null,
	AdmissionOfIdentity: null /*入學身份*/,
	IsComeBefore: null /*過去是否曾來台就讀*/,
	PersonalOfIdentity: null /*個人身份*/,
	SpecialOfIdentity: null /*特殊身份*/,
	GraduatedSchoolType: null /*畢業學校类型*/,
	GraduatedSchool: null /*畢業學校*/,
	DateOfGraduated: null /*畢業日期*/,
	Address: null /*通訊地址*/,
	HomeAddress: null /*戶籍地址*/,
	Telephone: null,
	Mobile: null,
	Email: null,
	ContactName: null /*緊急聯絡人*/,
	ContactRelationship: null /*緊急聯絡人關係*/,
	ContactPhone: null,
	ContactMobile: null,
	Description: null,
	Status: null,
	AdmissionOfQualification: null /*入學資格*/,
	NightTelephone: null /*夜間連絡電話*/,
	Nationality: null /*僑居地/國別/族別*/,
	DocumentaryStatus: StudentDocStatus.NotSubmitted,
}

export const FRESHMAN_APPLICATION_STATUS = {
	UnWriting: 'UnWriting', //資料尚未填寫
	Writing: 'Writing', //資料填寫中
	WriteDone: 'WriteDone', //資料填寫完
}
